import "./AppLayout.css";
import Logo from "../Logo";
import ToolBar from "../ToolBar";
import GerberList from "./leftside/GerberList";
import {ProgressSpinner} from "primereact/progressspinner";
import GridOffsetProperties from "../properties/GridOffsetProperties";
import EditorView from "../EditorView";
import RightPanel from "../rightpanel/RightPanel";
import HistorySync from "../HistorySync";
import {fileEditorStore} from "../../stores/FileEditorStore";
import React from "react";
import Layout from "../Layout";
import {fileListStore} from "../../stores/FileListStore";
import {ToolBarButtonType, toolBarStore} from "../../stores/ToolBarStore";

const additionalClass = "app"

function AppLayout() {
    const isLoading = fileListStore.loading
    toolBarStore.setButton(ToolBarButtonType.APP)
    return (<>
        <Layout
            header={<>
                <Logo/>
                <ToolBar/>
            </>}
            leftSide={<>
                <GerberList/>
                <div className={"load-icon " + (isLoading ? "visible" : "not-visible")}>
                    <ProgressSpinner
                        style={{width: '50px', height: '50px'}}
                        strokeWidth="3" fill="var(--surface-ground)"
                        animationDuration="1.0s"
                    />
                </div>
                <GridOffsetProperties/>
            </>}
            leftSideClasses={[additionalClass]}

            rightSide={<RightPanel/>}

            body={<EditorView/>}
            bodyClasses={[additionalClass]}

            footer={<>
                <div className={"to-right-direction"}>
                    <HistorySync/>
                    <div>{fileEditorStore.selectedFileName}</div>
                </div>
            </>}
        />
    </>)
}

export default AppLayout